import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const PopupContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 24px;
  width: 280px;
  z-index: 1000;
  animation: ${slideUp} 0.3s ease-out;
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p-color-icon);

  &:hover {
    color: var(--p-color-icon-hover);
  }
`;

export const IconContainer = styled.div`
  margin-bottom: 16px;
`;

export const StarIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: var(--p-color-text);
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: var(--p-color-text-secondary);
  margin: 0 0 16px 0;
`;

export const RatingWrapper = styled.div`
  background: #fef3c7;
  border-radius: 20px;
  padding: 12px 16px;
  margin-bottom: 16px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
`;

export const RatingContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export const StarButton = styled.button<{ $selected: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
  filter: ${({ $selected }) => ($selected ? 'none' : 'grayscale(100%)')};
  opacity: ${({ $selected }) => ($selected ? 1 : 0.4)};
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 1;
    filter: none;
  }
`;

export const ChatLink = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--p-color-text-link);

  &:hover {
    text-decoration: underline;
  }
`;
